<template>
  <div>

    <el-dialog
        :title="editMode ? '调整图片' : '上传图片'"
        :visible.sync="dialog"
        :before-close="closeDialog"
        width="30%"
        center>
      <el-form :model="resourceProportion" label-width="150px" ref="ResourceProportionForm">
        <el-form-item label="宽度占比(%)" prop="width"
                      :rules="[
                          { required: true, message: '不能为空'},
                          { validator: notLeNum0, trigger: 'blur' },
                          ]">
          <el-input v-model="resourceProportion.width" type="number"></el-input>
        </el-form-item>
        <el-form-item label="高度类型" prop="heightType">
          <el-select v-model="resourceProportion.heightType">
            <el-option
                v-for="item in heightTypes"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="resourceProportion.heightType==='1'" label="与宽度百分比(%)" prop="height"
                      :rules="[
                          { required: true, message: '不能为空'},
                          { validator: notLeNum0, trigger: 'blur' },
                          ]">
          <el-input v-model="resourceProportion.height" type="number"></el-input>
        </el-form-item>
        <el-form-item v-if="resourceProportion.heightType==='2'" label="自定义高度" prop="customHeight"
                      :rules="[
                          { required: true, message: '不能为空', trigger: 'blur' },
                          ]">
          <el-input v-model="resourceProportion.customHeight" placeholder="如 200px 或 50%"></el-input>
        </el-form-item>
        <el-form-item label="圆角(%)" prop="borderRadius"
                      :rules="[
                          { required: true, message: '不能为空'},
                          { validator: notLtNum0, trigger: 'blur' },
                          ]">
          <el-input v-model="resourceProportion.borderRadius" type="number"></el-input>
        </el-form-item>
        <el-form-item label="图片" prop="src"
                      :rules="editMode ? [] : [
                        {required: true, message: '请上传图片', trigger: 'blur'},
                        ]">
          <div class="avatar-uploader">
            <el-upload
                v-if="!editMode"
                :action="fileBaseUrl"
                :show-file-list="false"
                :data="uploadData"
                :before-upload="beforeUpload"
                :on-success="afterUpload"
                accept="image/*"
            >
              <img v-if="resourceProportion.src" :src="resourceProportion.src" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <img v-else-if="resourceProportion.src" :src="resourceProportion.src" class="avatar preview-only">
          </div>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
          <el-button :disabled="loading" type="primary" icon="el-icon-check"
                     @click="insertResource('ResourceProportionForm')">{{ editMode ? '应用' : '插入文章' }}</el-button>
        </span>
    </el-dialog>

  </div>
</template>
<script>


import dialogMixin from "@/mixin/dialogMixin";
import {notLeNum0, notLtNum0} from "@/utils/check";
import getAliyunOssSign from "@/api/common/aliyun/getAliyunOssSign";
import {generateUUID} from "@/utils/UUIDUtils";
import getFileSignUrl from "@/api/common/aliyun/getFileSignUrl";
import Axios from "axios";

export default {
  name: "DialogUploadImage",
  mixins: [dialogMixin],
  data() {
    return {
      fileBaseUrl: process.env.VUE_APP_FILE_BASE_URL,
      uploadData:{},
      loading: false,
      editMode: false,
      editingImage: null,
      resourceProportion:{
        widthType:'0',
        width:100,
        heightType:'0',
        height:100,
        customHeight: 'auto',
        borderRadius:0,
        src:undefined,
      },
      heightTypes:[
        {
          value:'0',
          label:'原比例'
        },
        {
          value:'1',
          label:'与宽度百分比'
        },
        {
          value:'2',
          label:'自定义高度'
        },
      ],
    }
  },
  methods: {
    notLtNum0,
    notLeNum0,
    getDefaultResourceProportion() {
      return {
        widthType: '0',
        width: 100,
        heightType: '0',
        height: 100,
        customHeight: 'auto',
        borderRadius: 0,
        src: undefined,
      }
    },
    resetForm() {
      this.editMode = false
      this.editingImage = null
      this.resourceProportion = this.getDefaultResourceProportion()
      if (this.$refs.ResourceProportionForm) {
        this.$refs.ResourceProportionForm.clearValidate()
      }
    },
    applyImageStyles(img, form) {
      img.style.borderRadius = `${form.borderRadius}%`
      img.style.width = `${form.width}%`
      img.style.removeProperty('height')
      img.style.removeProperty('aspect-ratio')
      if (form.heightType === '1') {
        img.style.aspectRatio = String(1 / form.height * 100)
      } else if (form.heightType === '2') {
        img.style.height = form.customHeight
      }
    },
    readImageForm(img) {
      const form = this.getDefaultResourceProportion()
      form.src = img.getAttribute('src')
      form.borderRadius = parseFloat(img.style.borderRadius) || 0
      form.width = parseFloat(img.style.width) || 100
      if (img.style.height && img.style.height !== 'auto') {
        form.heightType = '2'
        form.customHeight = img.style.height
      } else if (img.style.aspectRatio) {
        form.heightType = '1'
        const aspectRatio = parseFloat(img.style.aspectRatio)
        form.height = aspectRatio ? 100 / aspectRatio : 100
      } else {
        form.heightType = '0'
      }
      return form
    },
    prepareEdit(img) {
      if (!img) {
        return
      }
      this.editMode = true
      this.editingImage = img
      this.resourceProportion = this.readImageForm(img)
      if (this.$refs.ResourceProportionForm) {
        this.$refs.ResourceProportionForm.clearValidate()
      }
    },
    async preparePasteFile(file) {
      if (!file) {
        return
      }
      this.resetForm()
      this.loading = true
      try {
        const url = await this.uploadFileToOss(file)
        this.resourceProportion.src = url
      } catch (error) {
        this.$message.error('图片上传失败')
      } finally {
        this.loading = false
      }
    },
    async uploadFileToOss(file) {
      const response = await getAliyunOssSign('/common/sign')
      const resultObj = response.data
      const pre = `${resultObj.dir}/${generateUUID()}_`
      const formData = new FormData()
      formData.append('key', `${pre}\${filename}`)
      formData.append('OSSAccessKeyId', resultObj.accessid)
      formData.append('policy', resultObj.policy)
      formData.append('signature', resultObj.signature)
      formData.append('file', file)
      formData.append('success_action_status', '200')
      const uploadRes = await Axios.post(resultObj.host, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      if (uploadRes.status !== 200) {
        throw new Error('upload failed')
      }
      const urlRes = await getFileSignUrl(`${pre}${file.name}`)
      return urlRes.data
    },
    closeDialog() {
      this.resetForm()
      this.$emit('closed')
      this.noDialog()
    },
    afterUpload(response, file){
      //上传的完整的文件地址
      const urlPath = this.uploadData.host + '/' + this.uploadData.key.replace("${filename}", file.name);
      let name = urlPath.substring(this.fileBaseUrl.length+1)
      getFileSignUrl(name).then(res=>{
        this.resourceProportion.src = res.data
      })
    },
    async beforeUpload(){
      await getAliyunOssSign("/common/sign").then(response => {
        //设置相关的参数
        let resultObj = response.data;
        this.uploadData = resultObj;
        this.uploadData.ossaccessKeyId = resultObj.accessid;
        //上传的文件名，使用UUID处理一下
        this.uploadData.key = resultObj.dir + '/' + generateUUID() + '_${filename}';
      });
      return true
    },
    insertResource(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.editMode && this.editingImage) {
            this.applyImageStyles(this.editingImage, this.resourceProportion)
            this.$emit('image-updated', this.editingImage)
            this.closeDialog()
            return
          }
          const imgNode = document.createElement('img');
          imgNode.src = this.resourceProportion.src;
          this.applyImageStyles(imgNode, this.resourceProportion)
          const divNode = document.createElement('div');
          divNode.appendChild(imgNode);
          this.$emit('insert-node', divNode);
          this.closeDialog()
        } else {
          console.error('error submit!!');
          return false;
        }
      });
    },

  }
}
</script>
<style lang="scss" scoped>

.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100px;
  height: 60px;

  .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 60px;
    line-height: 60px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 60px;
    display: block;
  }
  .preview-only {
    object-fit: contain;
  }
}

</style>